/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


class EntityEntry
{
  constructor (entity)
  {
    this.entity = entity;
  }


  install ()
  {
    this.entity.install();
  }


  getPriority ()
  {
    return this.entity.getCass().create_date;
  }
};


// - - - - -


class SourceInteractionEntry
{
  constructor (interaction, parent)
  {
    this.interaction = interaction;
    this.parent = parent;
  }


  install ()
  {
    this.interaction.installSourcePlanet(this.parent);
  }


  getPriority ()
  {
    return this.interaction.getCass().create_date;
  }
};


// - - - - -


class TargetInteractionEntry
{
  constructor (interaction, parent)
  {
    this.interaction = interaction;
    this.parent = parent;
  }


  install ()
  {
    this.interaction.installTargetPlanet(this.parent);
  }


  getPriority ()
  {
    return this.interaction.getCass().create_date;
  }
};


// - - - - -


export default class
{
  constructor (parent)
  {
    this.parent = parent;

    this.collection = [];
  }


  pushEntity (entity)
  {
    this.collection.push(new EntityEntry(entity));
  }


  pushSourceInteraction (interaction)
  {
    this.collection.push(new SourceInteractionEntry(interaction, this.parent));
  }


  pushTargetInteraction (interaction)
  {
    this.collection.push(new TargetInteractionEntry(interaction, this.parent));
  }


  execute ()
  {
    this.collection.sort((lhs, rhs) =>
    {
      return lhs.getPriority() - rhs.getPriority();
    });

    for (const entry of this.collection)
    {
      entry.install();
    }
  }


};
